module.exports = __webpack_public_path__ + "static/img/文博智能体.39cf9a3.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/operationDecision/文博智能体.jpg
// module id = 7Uoo
// module chunks = 0